import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { Observable } from 'rxjs';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { ExtensionDetailFormService } from '../../extension-details/services/extension-detail-form.service';
import { AddScheduleHourFormData } from '../../schedule-hours/models/schedule-hours.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [ExtensionDetailFormService],
    selector: 'ndt-add-schedule-hour',
    styleUrls: ['./add-schedule-hour.component.scss'],
    templateUrl: './add-schedule-hour.component.html',
    standalone: false
})
export class AddScheduleHourComponent implements FormComponent {
   callState: Observable<CallState>;

   form: UntypedFormGroup;

   title: string;

   isAdd = true;

   constructor(
      private fb: UntypedFormBuilder,
      public dialogRef: MatDialogRef<AddScheduleHourComponent>,
      @Inject(MAT_DIALOG_DATA)
      public data: { scheduleHourFormData: AddScheduleHourFormData }
   ) {
      this.form = this.fb.group({
         closeTime: fb.control(
            data.scheduleHourFormData?.closeTime
               ? this.convertDateToTimeString(data.scheduleHourFormData.closeTime)
               : null
         ),
         dayOfWeek: fb.control({ dayOfWeek: data.scheduleHourFormData?.dayOfWeek ?? null }),
         openTime: fb.control(
            data.scheduleHourFormData?.openTime
               ? this.convertDateToTimeString(data.scheduleHourFormData.openTime)
               : null
         ),
         scheduleDetailId: fb.control(data.scheduleHourFormData?.scheduleDetailId ?? null),
         selectedDays: fb.control([]),
      });

      this.form.get('openTime')?.valueChanges.subscribe(() => {
         this.updateTimeRangeValidation();
      });

      this.form.get('closeTime')?.valueChanges.subscribe(() => {
         this.updateTimeRangeValidation();
      });

      data.scheduleHourFormData
         ? ((this.title = 'Edit Schedule Hour'), (this.isAdd = false))
         : (this.title = 'Add Schedule Hour');
   }

   onCloseClick(): void {
      this.dialogRef.close();
   }

   onCreate(): void {
      if (this.isAdd && this.form.get('selectedDays')?.value.length === 0) {
         this.form.get('selectedDays')?.setErrors({ invalidDayOfWeek: true });
      } else if (this.form.get(`dayOfWeek`)?.value == null) {
         this.form.get('dayOfWeek')?.setErrors({ invalidDayOfWeek: true });
      }
      if (this.form.valid) {
         this.dialogRef.close(this.form.value);
      }
   }

   private convertDateToTimeString(timeString: Date): string {
      const time = new Date(timeString);
      const hours = time.getUTCHours();
      const minutes = time.getUTCMinutes();
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
   }

   private updateTimeRangeValidation(): void {
      const openTimeControl = this.form.get('openTime');
      const closeTimeControl = this.form.get('closeTime');

      if (openTimeControl?.value && closeTimeControl?.value) {
         const isValidTimeRange = this.isOpenTimeValid();

         if (!isValidTimeRange) {
            openTimeControl?.setErrors({ invalidTimeRange: true });
            closeTimeControl?.setErrors({ invalidTimeRange: true });
         } else {
            openTimeControl?.setErrors(null);
            closeTimeControl?.setErrors(null);
         }
      }
   }

   private isOpenTimeValid(): boolean {
      const openTime = this.form?.get('openTime')?.value;
      const closeTime = this.form?.get('closeTime')?.value;
      return openTime && closeTime && openTime < closeTime;
   }
}
